// @flow
/** @jsx jsx */

import { jsx } from '@emotion/core';
import cn from 'classnames';
import Button from 'react-bootstrap/lib/Button';

type Props = {
  className?: string,
};

const Btn = ({ className = '', ...rest }: Props) => {
  return (
    <Button
      bsClass={cn(className, 'btn')}
      css={{
        minWidth: '130px',
      }}
      {...rest}
    />
  );
};

export default Btn;
